import { render, staticRenderFns } from "./UserAggregation.vue?vue&type=template&id=3ff41984&scoped=true"
import script from "./UserAggregation.vue?vue&type=script&lang=js"
export * from "./UserAggregation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff41984",
  null
  
)

export default component.exports